import { api } from './api';

const get = async () => {
  try {
    const result = await api.get(`/backoffice-funnel/schemaStep`);
    return result.data;
  } catch (err) {
    console.error(err);
    return { funnels: [] };
  }
};

const create = async data => {
  try {
    const result = await api.post(`/backoffice-funnel/schemaStep`, data);
    return result;
  } catch (err) {
    console.error(err);
    return {};
  }
};

const update = async (id, data) => {
  try {
    const result = await api.put(`/backoffice-funnel/schemaStep/${id}`, data);
    return result;
  } catch (err) {
    console.error(err);
    return {};
  }
};

const deleteSchemaStep = async id => {
  try {
    const result = await api.delete(`/backoffice-funnel/schemaStep/${id}`);
    return result;
  } catch (err) {
    console.error(err);
    return {};
  }
};

export default {
  get,
  create,
  update,
  deleteSchemaStep
};
